import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import type { Location } from 'history';

import BeforeUnload from 'components/BeforeUnload';

interface Props extends RouteComponentProps {
    message: string;
    when?: boolean;
    onlyPathname?: boolean;
}

export const ExitConfirmation = (props: Props): React.ReactElement => {
    const { when, message, location, onlyPathname } = props;

    const handlePrompt = (newLocation: Location): string | boolean => {
        let result: string | boolean = message;

        // only check pathname to prevent showing prompt when query string is changed
        if (onlyPathname && location.pathname === newLocation.pathname) {
            result = true;
        }

        return result;
    };

    return (
        <React.Fragment>
            <Prompt message={handlePrompt} when={when} />
            <BeforeUnload when={when} />
        </React.Fragment>
    );
};

ExitConfirmation.propTypes = {
    message: PropTypes.string.isRequired,
    when: PropTypes.bool,
    onlyPathname: PropTypes.bool
};

ExitConfirmation.defaultProps = {
    when: true,
    onlyPathname: false
};

export default withRouter(React.memo(ExitConfirmation));
